/* Rockee Redd 2.0: product page conversion layer. Runs on every product template. */
(function(){
  var d=document,cfgEl=d.getElementById('rr-pdp');
  if(!cfgEl){return;}
  var cfg;
  try{cfg=JSON.parse(cfgEl.textContent);}catch(e){return;}
  var info=d.querySelector('[id^=MainProduct-] .product__info-container')||d.querySelector('.product__info-container');
  if(!info){return;}
  var STAR='<svg width=\'14\' height=\'14\' viewBox=\'0 0 24 24\' fill=\'currentColor\'><path d=\'M12 2l3.1 6.3 6.9 1-5 4.9 1.2 6.8L12 17.8 5.8 21l1.2-6.8-5-4.9 6.9-1z\'/></svg>';
  var CHECK='<svg width=\'14\' height=\'14\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'currentColor\' stroke-width=\'1.8\' stroke-linecap=\'round\' stroke-linejoin=\'round\' aria-hidden=\'true\'><path d=\'M5 12.5l4.5 4.5L19 7.5\'/></svg>';
  function money(c){return '$'+(c/100).toFixed(2);}

  /* 1. rating under the title, linked to the reviews */
  var rating=parseFloat(cfg.rating)||0,count=parseInt(cfg.count,10)||0;
  var title=info.querySelector('.product__title');
  if(cfg.showRating&&count>0&&rating>0&&title&&!info.querySelector('.jdgm-preview-badge,.jdgm-prev-badge')){
    var a=d.createElement('a');
    a.className='rr-pdp-rating';
    a.href='#judgeme_product_reviews';
    a.setAttribute('aria-label',rating.toFixed(1)+' out of 5 stars, '+count+' reviews. Read the reviews.');
    var bar=d.createElement('span');bar.className='rr-starbar';bar.setAttribute('aria-hidden','true');
    var bg=d.createElement('span');bg.className='rr-starbar__bg';bg.innerHTML=STAR+STAR+STAR+STAR+STAR;
    var fg=d.createElement('span');fg.className='rr-starbar__fg';fg.style.width=Math.max(0,Math.min(100,rating/5*100))+'%';fg.innerHTML=STAR+STAR+STAR+STAR+STAR;
    bar.appendChild(bg);bar.appendChild(fg);
    var txt=d.createElement('span');txt.textContent=rating.toFixed(1)+' ';
    var u=d.createElement('u');u.textContent=count+' review'+(count===1?'':'s');
    a.appendChild(bar);a.appendChild(txt);a.appendChild(u);
    a.addEventListener('click',function(e){
      var target=d.querySelector('#judgeme_product_reviews,.jdgm-review-widget');
      if(!target){return;}
      e.preventDefault();
      target.scrollIntoView({behavior:'smooth',block:'start'});
    });
    title.insertAdjacentElement('afterend',a);
  }

  /* 2. reassurance directly under the add to cart button */
  var perks=(cfg.perks||[]).filter(function(p){return p&&String(p).trim();});
  var pf=info.querySelector('product-form');
  var host=pf&&pf.closest('.product__info-container>*');
  var anchor=host;
  if(perks.length&&host){
    var ul=d.createElement('ul');ul.className='rr-perks';
    perks.forEach(function(p){
      var li=d.createElement('li');li.innerHTML=CHECK;
      var s=d.createElement('span');s.textContent=p;li.appendChild(s);ul.appendChild(li);
    });
    host.insertAdjacentElement('afterend',ul);
    anchor=ul;
  }

  /* 3. long descriptions fold, so ingredients and reviews stay within reach on a phone */
  var desc=info.querySelector('.product__description');
  if(desc&&desc.scrollHeight>280){
    desc.classList.add('rr-clamp');
    var more=d.createElement('button');
    more.type='button';more.className='rr-more';more.textContent='read more';more.setAttribute('aria-expanded','false');
    more.addEventListener('click',function(){
      var open=desc.classList.toggle('rr-clamp--open');
      more.textContent=open?'read less':'read more';
      more.setAttribute('aria-expanded',open?'true':'false');
    });
    desc.insertAdjacentElement('afterend',more);
  }

  var mainEl=d.querySelector('[id^=MainProduct-]');
  var mainSec=mainEl&&mainEl.closest('.shopify-section');
  var idInput=info.querySelector('input[name=product-id]');
  var pinfo=d.querySelector('product-info[data-product-id]');
  var productId=idInput?idInput.value:(pinfo?pinfo.getAttribute('data-product-id'):'');
  var handle=(window.location.pathname.match(/\/products\/([^\/?#]+)/)||[])[1]||'';
  var keep=d.documentElement.classList.contains('rr-keep-order');
  var base=(window.routes&&window.routes.product_recommendations_url)||'/recommendations/products';

  /* 4. complete the routine: at most two hand-picked partners under the button.
        Source 1: complementary products chosen in Shopify Search & Discovery. Source 2: the pairs list in theme settings. */
  function routineRow(p){
    var row=d.createElement('div');row.className='rr-addon';
    var url=p.url||('/products/'+p.handle);
    if(p.featured_image){var img=d.createElement('img');img.src=p.featured_image+(p.featured_image.indexOf('?')>-1?'&':'?')+'width=160';img.alt='';img.loading='lazy';img.width=52;img.height=64;row.appendChild(img);}
    var box=d.createElement('div');box.className='rr-addon__info';
    var t=d.createElement('a');t.href=url;t.textContent=p.title;box.appendChild(t);
    var s=d.createElement('span');
    s.textContent=(p.price_varies||p.price_min!==p.price_max)?(money(p.price_max)+' \u00b7 starting at '+money(p.price_min)):money(p.price);
    box.appendChild(s);row.appendChild(box);
    var single=p.variants&&p.variants.length===1&&!p.requires_selling_plan&&p.variants[0].available;
    if(single){
      var b=d.createElement('button');b.type='button';b.setAttribute('data-rr-add',p.variants[0].id);b.setAttribute('data-rr-url',url);b.setAttribute('aria-label','Add '+p.title+' to cart');b.textContent='add';row.appendChild(b);
    }else{
      var l=d.createElement('a');l.className='rr-addon__go';l.href=url;l.textContent='choose';row.appendChild(l);
    }
    return row;
  }
  function renderRoutine(products){
    products=(products||[]).filter(function(p){return p&&p.title&&p.available!==false&&p.handle!==handle;}).slice(0,2);
    if(!products.length||!anchor){return;}
    var wrap=d.createElement('div');wrap.className='rr-routine';
    var h=d.createElement('p');h.className='rr-addons__title';h.textContent=cfg.routineTitle||'complete the routine';
    wrap.appendChild(h);
    products.forEach(function(p){wrap.appendChild(routineRow(p));});
    anchor.insertAdjacentElement('afterend',wrap);
  }
  function pairsFor(h){
    var out=[];
    String(cfg.pairs||'').split('|').forEach(function(part){
      var kv=part.split(':');
      if(kv.length===2&&kv[0].trim()===h){out=kv[1].split(',').map(function(x){return x.trim();}).filter(Boolean);}
    });
    return out;
  }
  if(productId&&!keep){
    fetch(base+'.json?product_id='+encodeURIComponent(productId)+'&limit=2&intent=complementary')
      .then(function(r){return r.ok?r.json():{products:[]};})
      .then(function(data){
        if(data.products&&data.products.length){renderRoutine(data.products);return;}
        var list=pairsFor(handle);
        if(!list.length){return;}
        return Promise.all(list.map(function(h){
          return fetch('/products/'+encodeURIComponent(h)+'.js').then(function(r){return r.ok?r.json():null;}).catch(function(){return null;});
        })).then(renderRoutine);
      })
      .catch(function(){});
  }

  /* 5. you may also like: added under the buy area wherever the template does not already show related products */
  if(mainSec&&productId&&!keep&&!d.querySelector('product-recommendations')){
    fetch(base+'?section_id=rr-recs&product_id='+encodeURIComponent(productId)+'&limit=4&intent=related')
      .then(function(r){return r.ok?r.text():'';})
      .then(function(html){
        if(!html){return;}
        var tmp=d.createElement('div');tmp.innerHTML=html;
        var sec=tmp.querySelector('.rr-recs');
        if(!sec){return;}
        var wrap=d.createElement('div');
        wrap.className='rr-recs-wrap';
        wrap.style.order='-1';
        wrap.appendChild(sec);
        mainSec.insertAdjacentElement('afterend',wrap);
        requestAnimationFrame(function(){
          wrap.querySelectorAll('[data-rr-reveal]').forEach(function(el){el.classList.add('is-in');});
        });
      })
      .catch(function(){});
  }
})();
